<template>
  <div class="min-h-screen flex" v-loading.fullscreen.lock="loading">
    <div class="hidden lg:block relative w-0 flex-1">
      <img
        class="absolute inset-0 h-full w-full object-cover opacity-80"
        src="@/assets/images/bg.ac4083d7.jpg"
        alt="Background"
      />
      <div
        class="absolute bottom-0 w-full px-5 pb-6"
        style="background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0, rgba(0, 0, 0, 0.3))"
      >
        <p class="text-4xl text-white-thin mb-8 pt-1">{{ $t('message.easyManagement') }}</p>
        <p class="text-xs text-white-thin">
          {{ $t('label.copyright') }}
        </p>
      </div>
    </div>

    <div class="flex flex-col bg-white relative w-full lg:w-4/12">
      <div class="w-full px-5 lg:px-16 pt-20">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
        <div class="mt-4 text-right">
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import type { RootState } from 'store'
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import env from 'core/env'
import LanguageSwitcher from './components/LanguageSwitcher/index.vue'

export default defineComponent({
  components: {
    LanguageSwitcher,
  },
  setup() {
    const version = ref(env('VITE_APP_VERSION', '0.0.0'))
    const store = useStore<RootState>()
    const loading = computed(() => store.state.loading)
    return {
      loading,
      version,
    }
  },
})
</script>
<style lang="scss">
.text-white-thin {
  @apply text-white font-thin;
}
</style>
